<template>
  <v-nav/>
  <a-row>
    <a-col :span="7">
      <page-title :brain-type="$t('standardBrain')" :menu-name="$t('fibreBundleMapping')"
                  style="position:absolute;width: 1000px"/>
      <div class="condition-content cibr-self">
        <div class="option-panel" style="margin-bottom: 10px">
          <a-row>
            <a-col :span="8">
              <a-checkbox v-model:checked="showBrain">{{ $t("showSurface") }}</a-checkbox>
            </a-col>
            <a-col :span="4" style="color: white">
              透明度
            </a-col>
            <a-col :span="12">
              <a-slider id="test" v-model:value="opacity" :disabled="!showBrain" :min="0" :max="0.3" :step="0.001"/>
            </a-col>
          </a-row>
        </div>
        <fibre-select v-model:value="selectList"></fibre-select>
      </div>
    </a-col>
    <a-col :span="17">
      <div id="fibreContainer" style="width: 100%;" :style="{height : contentHeight}">
      </div>
    </a-col>
  </a-row>
  <v-loading :show="loading"></v-loading>
</template>

<script>
// zhouhan@cibr.ac.cn 2022/11/17 13:37
import VLoading from "@/components/public/v-loading";
import VNav from "@/components/public/VNav";
import vtkRenderWindowWithControlBar from "@kitware/vtk.js/Rendering/Misc/RenderWindowWithControlBar";
import vtkUtil from "@/util/vtkUtil";
import util from "@/util/util";
import PageTitle from "@/components/public/pageTitle";
import FibreSelect from "@/components/public/fibreSelect.vue";

export default {
  name: "standardFibre",
  components: {FibreSelect, PageTitle, VNav, VLoading},
  data() {
    return {
      showBrain: false,
      mashBrain : {},
      loading: false,
      contentHeight: 0,
      selectList: [],
      fibreActorList: [],
      renderer: {},
      renderWindow: {},
      vtkActorList: [],
      existsModal: {},
      opacity : 0.03
    }
  },
  beforeMount() {
    this.computedHeight();
  },
  mounted() {
    window.onresize = () => {
      this.computedHeight()
    }
    this.initPage();
  },
  methods: {
    showMask() {
      this.loading = true;
    },
    hideMask() {
      this.loading = false;
    },
    initPage() {
      const fullScreenRenderer = vtkRenderWindowWithControlBar.newInstance();
      fullScreenRenderer.setControlSize(0)
      this.renderer = fullScreenRenderer.getRenderer();
      this.renderer.setBackground(0, 0, 0, 0)
      fullScreenRenderer.setContainer(document.getElementById("fibreContainer"))
      this.renderWindow = fullScreenRenderer.getRenderWindow();
      // vtkUtil.getVtkActor2(util.personalUrl + "standard/all.vtk", (res)=>{
      //   vtkUtil.smallNav(this.renderer, this.renderWindow, res.actor);
      // })

      vtkUtil.getObjActor(util.baseUrl + "surface_2f.obj", (res) => {
        vtkUtil.smallNav(this.renderer, this.renderWindow, res.actor);
      })
      vtkUtil.getObjActor(util.baseUrl + "surface_2f.obj", (res) => {
        this.mashBrain = res.actor;
      })
      this.loadModal();
    },
    loadModal() {
      this.showMask();
      vtkUtil.readVtkFile(util.personalUrl + "standard/all_ds.vtk",
          this.renderer, this.renderWindow, 0.01, () => {
            this.renderer.resetCamera();
            this.renderWindow.render();
            this.hideMask();
          });
    },
    computedHeight() {
      this.contentHeight = (window.innerHeight - 48) + "px";
    },
    loadNewModal(modal) {
      vtkUtil.readVtkFile(util.personalUrl + "standard/" + modal + ".vtk",
          this.renderer, this.renderWindow, 1, (res) => {
            this.existsModal[modal] = res.actor;
          });
    },
    showNewModal(modalList) {
      if (util.isNull(modalList)) {
        return;
      }
      modalList.map(item => {
        var actor = this.existsModal[item];
        if (util.isNull(actor)) {
          this.loadNewModal(item);
        } else {
          this.renderer.addActor(actor);
        }
      })
      this.renderWindow.render();
    },
    removeModal(oldModal) {
      if (util.isNull(oldModal)) {
        return;
      }
      console.log(oldModal)
      oldModal.map(item => {
        this.renderer.removeActor(this.existsModal[item]);
      })
      this.renderWindow.render();
    }
  },
  watch: {
    newList(newVal, oldVal) {
      console.log(newVal, oldVal);
      var newModal = newVal.filter(item => !oldVal.includes(item));
      this.showNewModal(newModal);
      var oldModal = oldVal.filter(item => !newVal.includes(item));
      this.removeModal(oldModal);
    },
    opacity(){
      this.mashBrain.getProperty().setOpacity(this.opacity);
      this.renderWindow.render();
    },
    showBrain(){
      if (this.showBrain){
        this.mashBrain.getProperty().setOpacity(this.opacity);
        this.renderer.addActor(this.mashBrain);
      }else {
        this.renderer.removeActor(this.mashBrain)
      }
      this.renderWindow.render();
    }
  },
  computed: {
    newList() {
      return JSON.parse(JSON.stringify(this.selectList))
    },
  }
}
</script>

<style scoped>
.pickList {
  font-size: 20px;
  color: white;
}

.condition-content {
  /*background-color: #5A2781;*/
  /*border-radius: 20px;*/
  /*border: 1px #552D6D solid;*/
  position: absolute;
  top: 40px;
  margin-top: 80px;
  padding: 16px 16px;
  width: 100%;
}
</style>